import { all } from "redux-saga/effects";
import { mapControlSaga } from "./components/map-control/sagas";
import { mapToolsSaga } from "./components/map-tools/sagas";

export const mapSaga = function* () {
    yield all([mapControlSaga(), mapToolsSaga()]);
};
